import React from 'react';
import {
  Button,
  Widget
} from '@digital/ui';
import { Table } from 'antd';

import { CrfOrcamentoPlanilha } from '@app/api/crf/crfOrcado';

interface ICrfTablePlanilhasProps {
  dataPlanilhas: CrfOrcamentoPlanilha[];
  handleClick(item: CrfOrcamentoPlanilha): void;
}

export const initialState: CrfOrcamentoPlanilha = {
  revisao: 0,
  numero: 0,
  dataAprovacao: '',
  nome: '',
  projetoId: '',
  id: '',
  status: '',
  numberIndex: 0,
};

const CrfTablePlanilha = ({ dataPlanilhas, handleClick }: ICrfTablePlanilhasProps) => {

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'numberIndex',
        width: '2%',
      },
      {
        title: 'Revisão',
        dataIndex: 'revisao',
        width: '8%',
      },
      {
        title: 'Número',
        dataIndex: 'numero',
        width: '10%',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        width: '10%',
      },
      {
        title: 'Data aprovação',
        dataIndex: 'dataAprovacao',
        width: '20%',
      },
      {
        title: 'Nome do arquivo',
        dataIndex: 'nome',
        width: '50%',
      },
      {
        title: 'Ações',
        render: (item: CrfOrcamentoPlanilha) => (
          <>
            <Button
              onClick={() => handleClick(item)}
              icon="files-xls"
              style={{ width: 43, margin: 4, textAlign: 'center' }}
            />
          </>
        ),
      },
    ];
  };

  return (
    <>
      <Widget title="Planilhas" style={{ textAlign: 'center' }}>
        <Table
          className="removeScrollbar"
          rowKey="id"
          columns={customColumns()}
          dataSource={dataPlanilhas}
          pagination={false}
        />
      </Widget>
    </>
  );
};

export default CrfTablePlanilha;
